"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vuex_1 = __importDefault(require("vuex"));
function createDirectStore(options) {
    const original = new vuex_1.default.Store(options);
    const store = {
        get state() {
            return original.state;
        },
        getters: gettersFromOptions({}, options, original.getters),
        commit: commitFromOptions({}, options, original.commit),
        dispatch: dispatchFromOptions({}, options, original.dispatch),
        original
    };
    original.direct = store;
    return {
        store,
        rootActionContext: rootActionContextProvider(store),
        moduleActionContext: (originalContext, module) => getModuleActionContext(originalContext, module, store)
    };
}
exports.createDirectStore = createDirectStore;
// Getters
function gettersFromOptions(result, options, originalGetters, hierarchy = []) {
    if (options.getters)
        createDirectGetters(result, options.getters, originalGetters, hierarchy);
    if (options.modules) {
        for (const [moduleName, moduleOptions] of Object.entries(options.modules)) {
            if (moduleOptions.namespaced)
                result[moduleName] = gettersFromOptions({}, moduleOptions, originalGetters, [...hierarchy, moduleName]);
            else
                gettersFromOptions(result, moduleOptions, originalGetters, hierarchy);
        }
    }
    return result;
}
function createDirectGetters(result, gettersImpl, originalGetters, hierarchy) {
    const prefix = !hierarchy || hierarchy.length === 0 ? "" : `${hierarchy.join("/")}/`;
    for (const name of Object.keys(gettersImpl)) {
        Object.defineProperties(result, {
            [name]: {
                get: () => originalGetters[`${prefix}${name}`]
            }
        });
    }
}
// Mutations
function commitFromOptions(result, options, originalCommit, hierarchy = []) {
    if (options.mutations)
        createDirectMutations(result, options.mutations, originalCommit, hierarchy);
    if (options.modules) {
        for (const [moduleName, moduleOptions] of Object.entries(options.modules)) {
            if (moduleOptions.namespaced)
                result[moduleName] = commitFromOptions({}, moduleOptions, originalCommit, [...hierarchy, moduleName]);
            else
                commitFromOptions(result, moduleOptions, originalCommit, hierarchy);
        }
    }
    return result;
}
function createDirectMutations(result, mutationsImpl, originalCommit, hierarchy) {
    const prefix = !hierarchy || hierarchy.length === 0 ? "" : `${hierarchy.join("/")}/`;
    for (const name of Object.keys(mutationsImpl))
        result[name] = (payload) => originalCommit(`${prefix}${name}`, payload);
}
// Actions
function dispatchFromOptions(result, options, originalDispatch, hierarchy = []) {
    if (options.actions)
        createDirectActions(result, options.actions, originalDispatch, hierarchy);
    if (options.modules) {
        for (const [moduleName, moduleOptions] of Object.entries(options.modules)) {
            if (moduleOptions.namespaced)
                result[moduleName] = dispatchFromOptions({}, moduleOptions, originalDispatch, [...hierarchy, moduleName]);
            else
                dispatchFromOptions(result, moduleOptions, originalDispatch, hierarchy);
        }
    }
    return result;
}
function createDirectActions(result, actionsImpl, originalDispatch, hierarchy) {
    const prefix = !hierarchy || hierarchy.length === 0 ? "" : `${hierarchy.join("/")}/`;
    for (const name of Object.keys(actionsImpl))
        result[name] = (payload) => originalDispatch(`${prefix}${name}`, payload);
}
// ActionContext
const actionContexts = new WeakMap();
function getModuleActionContext(originalContext, options, store) {
    let context = actionContexts.get(originalContext.dispatch);
    if (!context) {
        context = createModuleActionContext(options, originalContext, store);
        actionContexts.set(originalContext.dispatch, context);
    }
    return context;
}
function createModuleActionContext(options, originalContext, store) {
    return {
        get rootState() {
            return originalContext.rootState;
        },
        rootGetters: store.getters,
        rootCommit: store.commit,
        rootDispatch: store.dispatch,
        get state() {
            return originalContext.state;
        },
        getters: gettersFromOptions({}, options, originalContext.getters),
        commit: commitFromOptions({}, options, originalContext.commit),
        dispatch: dispatchFromOptions({}, options, originalContext.dispatch)
    };
}
function rootActionContextProvider(store) {
    return (originalContext) => {
        let context = actionContexts.get(originalContext.dispatch);
        if (!context) {
            context = createRootActionContext(originalContext, store);
            actionContexts.set(originalContext.dispatch, context);
        }
        return context;
    };
}
function createRootActionContext(originalContext, store) {
    return {
        get rootState() {
            return originalContext.rootState;
        },
        rootGetters: store.getters,
        rootCommit: store.commit,
        rootDispatch: store.dispatch,
        get state() {
            return originalContext.state;
        },
        getters: store.getters,
        commit: store.commit,
        dispatch: store.dispatch
    };
}
